import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoaderService } from './loader.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-loader',
  standalone: false,
  templateUrl: './loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnInit {
 
  isLoading: boolean = false;
  constructor(private loaderService: LoaderService) {
  }
  ngOnInit(): void {
    this.loaderService.isLoading.subscribe((loading: boolean) => {
      this.isLoading = loading;
    });
  }



}
